"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var StyledGrid_1 = require("./StyledGrid");
var GridInner = function (props) {
    var fill = props.fill, // munged to avoid styled-components putting it in the DOM
    rows = props.rows, // munged to avoid styled-components putting it in the DOM
    tag = props.tag, as = props.as, children = props.children, columns = props.columns, rest = tslib_1.__rest(props, ["fill", "rows", "tag", "as", "children", "columns"]);
    var rowPos = 1;
    var columnCount = 1;
    if (columns) {
        if (Array.isArray(columns)) {
            columnCount = columns.length;
        }
        else if (columns && typeof columns === 'object' && typeof columns.count === 'number') {
            columnCount = columns.count;
        }
    }
    var gridAvailable = typeof window !== 'undefined' && window.CSS && window.CSS.supports && window.CSS.supports('display', 'grid');
    return (React.createElement(StyledGrid_1.StyledGrid, tslib_1.__assign({ as: tag || 'div', fillContainer: fill, rowsProp: rows, gridAvailable: gridAvailable, columns: columns }, rest), gridAvailable
        ? children
        : React.Children.toArray(children).map(function (child, index) {
            var indexPos = index + 1;
            var calculatedCol = indexPos % columnCount === 0 ? columnCount : indexPos % columnCount;
            var columnPos = indexPos > columnCount ? calculatedCol : index + 1;
            if (index % columnCount === 0) {
                rowPos++;
            }
            return (React.createElement(StyledGrid_1.StyledGridChild, tslib_1.__assign({ key: index, columnPosition: columnPos, rowPosition: rowPos }, rest), child));
        })));
};
GridInner.defaultProps = {
    tag: 'div'
};
/** @component */
exports.Grid = recompose_1.compose(styled_components_1.withTheme)(GridInner);
//# sourceMappingURL=Grid.js.map